import React from "react";
import Footer from "../Components/Footer";
import NavBar from "../Components/NavBar";
const About = () => {
  return (
    <>
      <div className="pages">
        <NavBar />
       <div id="about-us">

       <section id="about-us-text-components">
 <div className="light-background">
          <h1> Beast-O Technology</h1>

          <p>  Beast-O Technology is an emerging high-tech company from Zimbabwe founded in 2022 with the big dream of connecting people with people and people with the environment.
          We are in a world of information where the amount of data you have at your disposal determines the number of things you control. Our dream is to connect people with the 
          resources which they need to conquer their daily problems quickly and affordably. Our fundamental principle of operation is customer-centric. Every decision we make is determined by the results of 
          surveys and research we conduct regularly to understand market needs.     </p>

        </div>
        <div id="values"  className="light-background">
          <h1>Our Values</h1>
          <h3>Loyalty</h3>
          <p>
            Loyalty is our top priority. The main goal of our organization is to maintain a  community  you can trust and rely on at any time. A community that stands by its members no matter the circumstances. 
          </p>
          <h3> Agility</h3>
          <p>
            The world is changing day by day. Why not us also? We keep up with
            time, we are never behind. We value the art of being flexible. We
            are not afraid of change.
          </p>
          <h3>Transparency</h3>
          <p>
            {" "}
            Everything at beast-o is crystal clear. We do not believe in hidden
            paths and secrets. We value to put all the stakeholders on 1 page
            because we are more than an organization but rather a large family.
            Everything you need to know is always at your disposal.
          </p>

          <h3>Excellence</h3>
          <p>
            We are the best because we are always chasing excellence. Some say
            perfectionism is a root to failure, we disagree with that notion. As
            we try to be perfect, we make mistakes along the way . We learn from
            those mistakes that is why we are always improving. We will never
            stop to improve because excellence is our limit and it cannot be
            reached.
          </p>
        </div>
        <div id="our-team"  className="light-background">
          <h1>Our Team</h1>
          <p>
            We have a diverse team, with people from different social
            backgrounds. Those difference makes us unique in a positive way as
            we learn from each other. In our team every voice is equal, everyone
            can make a difference. Our customers are also part of our big team.
            We always engage with them as much as we can because they deserve
            that sense of belonging to the team.
          </p>
        </div>

       </section>
<section>

</section>

       </div>
      </div>
      <Footer />
    </>
  );
};
export default About;
